// import React, { useState, useEffect, useRef } from "react";
// import "../style/ExtraSections.css"; // your fade/slide styles

// const sections = [
//   {
//     id: "faqs",
//     title: "FAQs ❓",
//     content: (
//       <div className="space-y-4 text-left">
//         <p><strong>Q:</strong> How do I get started?<br/> <strong>A:</strong> Just click “🚀 Start Now” and complete a quick quiz!</p>
//         <p><strong>Q:</strong> Is this service free?<br/> <strong>A:</strong> Yes, the basic roadmap is free, premium mentorship is optional.</p>
//         <p><strong>Q:</strong> Who are the mentors?<br/> <strong>A:</strong> 👩‍🏫 Industry professionals with 10+ years of experience.</p>
//       </div>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/4712/4712035.png",
//   },
//   {
//     id: "careers",
//     title: "Careers 💼",
//     content: (
//       <div className="space-y-3">
//         <p>🌟 We’re always looking for passionate mentors and developers.</p>
//         <ul className="list-disc list-inside">
//           <li>Career Mentors 👨‍🏫</li>
//           <li>UI/UX Designers 🎨</li>
//           <li>Marketing Specialists 📈</li>
//         </ul>
//         <p className="mt-4">📧 Send your resume to <a href="mailto:careers@scp.com" className="text-indigo-600">careers@scp.com</a></p>
//       </div>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/3135/3135683.png",
//   },
//   {
//     id: "blog",
//     title: "Blog ✍️",
//     content: (
//       <ul className="list-disc list-inside space-y-2 text-left">
//         <li>📌 How to Choose the Right Career Path</li>
//         <li>📌 Top 5 Skills Employers Want in 2025</li>
//         <li>📌 Balancing Studies & Internships</li>
//       </ul>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/1159/1159790.png",
//   },
//   {
//     id: "guides",
//     title: "Guides 📘",
//     content: (
//       <ol className="list-decimal list-inside space-y-2 text-left">
//         <li>📝 Building your first resume</li>
//         <li>🎤 Preparing for interviews</li>
//         <li>💻 Learning roadmap for coding, design, business</li>
//       </ol>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/2991/2991148.png",
//   },
//   {
//     id: "privacy",
//     title: "Privacy Policy 🔒",
//     content: (
//       <p>
//         We collect only essential data to personalize your roadmap.  
//         🔐 Your information is <strong>never</strong> shared with third parties.  
//         Request deletion anytime 👉 <a href="mailto:privacy@scp.com" className="text-indigo-600">privacy@scp.com</a>.
//       </p>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/3064/3064197.png",
//   },
//   {
//     id: "terms",
//     title: "Terms & Conditions 📜",
//     content: (
//       <p>
//         By using <strong>Systematic Career Planner</strong>, you agree to:  
//         ✅ Use the platform responsibly.  
//         ❌ Not misuse or copy data.  
//         📖 Respect our intellectual property.  
//       </p>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/3135/3135676.png",
//   },
// ];

// export default function ExtraSections() {
//   const [current, setCurrent] = useState(0);
//   const touchStartY = useRef(null);

//   // Handle scroll wheel (desktop)
//   useEffect(() => {
//     let cooldown = false;
//     const handleScroll = (e) => {
//       if (cooldown) return;
//       cooldown = true;

//       if (e.deltaY > 0) {
//         setCurrent((prev) => (prev + 1) % sections.length);
//       } else if (e.deltaY < 0) {
//         setCurrent((prev) => (prev - 1 + sections.length) % sections.length);
//       }

//       setTimeout(() => (cooldown = false), 800);
//     };

//     window.addEventListener("wheel", handleScroll);
//     return () => window.removeEventListener("wheel", handleScroll);
//   }, []);

//   // Handle swipe (mobile)
//   useEffect(() => {
//     const handleTouchStart = (e) => {
//       touchStartY.current = e.touches[0].clientY;
//     };
//     const handleTouchEnd = (e) => {
//       if (touchStartY.current === null) return;
//       const deltaY = touchStartY.current - e.changedTouches[0].clientY;

//       if (Math.abs(deltaY) > 50) {
//         if (deltaY > 0) {
//           // swipe up
//           setCurrent((prev) => (prev + 1) % sections.length);
//         } else {
//           // swipe down
//           setCurrent((prev) => (prev - 1 + sections.length) % sections.length);
//         }
//       }
//       touchStartY.current = null;
//     };

//     window.addEventListener("touchstart", handleTouchStart);
//     window.addEventListener("touchend", handleTouchEnd);

//     return () => {
//       window.removeEventListener("touchstart", handleTouchStart);
//       window.removeEventListener("touchend", handleTouchEnd);
//     };
//   }, []);

//   return (
//     <section
//       id="extra-sections"
//       className="relative h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-purple-50 overflow-hidden"
//     >
//       {sections.map((sec, idx) => (
//         <div
//           key={sec.id}
//           className={`absolute inset-0 flex flex-col items-center justify-center px-6 text-center transition-all duration-700 ${
//             idx === current
//               ? "opacity-100 translate-y-0 z-10"
//               : "opacity-0 translate-y-10 z-0"
//           }`}
//         >
//           <img
//             src={sec.img}
//             alt={sec.title}
//             className="w-24 h-24 mb-6 drop-shadow-lg"
//           />
//           <h2 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-600 mb-6">
//             {sec.title}
//           </h2>
//           <div className="text-lg md:text-xl max-w-2xl text-gray-700 leading-relaxed">
//             {sec.content}
//           </div>
//         </div>
//       ))}

//       {/* Navigation Dots */}
//       <div className="absolute bottom-6 flex gap-3">
//         {sections.map((_, idx) => (
//           <button
//             key={idx}
//             onClick={() => setCurrent(idx)}
//             className={`w-3 h-3 rounded-full transition ${
//               idx === current ? "bg-pink-500 scale-125" : "bg-gray-300"
//             }`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// }

// import React, {
//   useState,
//   useEffect,
//   useRef,
//   forwardRef,
//   useImperativeHandle,
// } from "react";
// import "../style/ExtraSections.css";

// const sections = [
//   {
//     id: "faqs",
//     title: "FAQs ❓",
//     content: (
//       <div className="space-y-4 text-left">
//         <p>
//           <strong>Q:</strong> How do I get started?<br />
//           <strong>A:</strong> Just click “🚀 Start Now” and complete a quick quiz!
//         </p>
//         <p>
//           <strong>Q:</strong> Is this service free?<br />
//           <strong>A:</strong> Yes, the basic roadmap is free, premium mentorship is optional.
//         </p>
//         <p>
//           <strong>Q:</strong> Who are the mentors?<br />
//           <strong>A:</strong> 👩‍🏫 Industry professionals with 10+ years of experience.
//         </p>
//       </div>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/4712/4712035.png",
//   },
//   {
//     id: "careers",
//     title: "Careers 💼",
//     content: (
//       <div className="space-y-3">
//         <p>🌟 We’re always looking for passionate mentors and developers.</p>
//         <ul className="list-disc list-inside">
//           <li>Career Mentors 👨‍🏫</li>
//           <li>UI/UX Designers 🎨</li>
//           <li>Marketing Specialists 📈</li>
//         </ul>
//         <p className="mt-4">
//           📧 Send your resume to{" "}
//           <a href="mailto:careers@scp.com" className="text-indigo-600">
//             careers@scp.com
//           </a>
//         </p>
//       </div>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/3135/3135683.png",
//   },
//   {
//     id: "blog",
//     title: "Blog ✍️",
//     content: (
//       <ul className="list-disc list-inside space-y-2 text-left">
//         <li>📌 How to Choose the Right Career Path</li>
//         <li>📌 Top 5 Skills Employers Want in 2025</li>
//         <li>📌 Balancing Studies & Internships</li>
//       </ul>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/1159/1159790.png",
//   },
//   {
//     id: "guides",
//     title: "Guides 📘",
//     content: (
//       <ol className="list-decimal list-inside space-y-2 text-left">
//         <li>📝 Building your first resume</li>
//         <li>🎤 Preparing for interviews</li>
//         <li>💻 Learning roadmap for coding, design, business</li>
//       </ol>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/2991/2991148.png",
//   },
//   {
//     id: "privacy",
//     title: "Privacy Policy 🔒",
//     content: (
//       <p>
//         We collect only essential data to personalize your roadmap. <br />
//         🔐 Your information is <strong>never</strong> shared with third parties. <br />
//         Request deletion anytime 👉{" "}
//         <a href="mailto:privacy@scp.com" className="text-indigo-600">
//           privacy@scp.com
//         </a>
//         .
//       </p>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/3064/3064197.png",
//   },
//   {
//     id: "terms",
//     title: "Terms & Conditions 📜",
//     content: (
//       <p>
//         By using <strong>Systematic Career Planner</strong>, you agree to: <br />
//         ✅ Use the platform responsibly. <br />
//         ❌ Not misuse or copy data. <br />
//         📖 Respect our intellectual property. <br />
//       </p>
//     ),
//     img: "https://cdn-icons-png.flaticon.com/512/3135/3135676.png",
//   },
// ];

// const ExtraSections = forwardRef((props, ref) => {
//   const [current, setCurrent] = useState(0);
//   const touchStartY = useRef(null);

//   // expose goToSection to parent (for footer quick links)
//   useImperativeHandle(ref, () => ({
//     goToSection: (id) => {
//       const index = sections.findIndex((s) => s.id === id);
//       if (index !== -1) setCurrent(index);
//     },
//   }));

//   // Handle scroll (desktop)
//   useEffect(() => {
//     let cooldown = false;
//     const handleScroll = (e) => {
//       if (cooldown) return;
//       cooldown = true;

//       if (e.deltaY > 0) {
//         setCurrent((prev) => (prev + 1) % sections.length);
//       } else if (e.deltaY < 0) {
//         setCurrent((prev) => (prev - 1 + sections.length) % sections.length);
//       }

//       setTimeout(() => (cooldown = false), 800);
//     };

//     window.addEventListener("wheel", handleScroll);
//     return () => window.removeEventListener("wheel", handleScroll);
//   }, []);

//   // Handle swipe (mobile)
//   useEffect(() => {
//     const handleTouchStart = (e) => {
//       touchStartY.current = e.touches[0].clientY;
//     };
//     const handleTouchEnd = (e) => {
//       if (touchStartY.current === null) return;
//       const deltaY = touchStartY.current - e.changedTouches[0].clientY;

//       if (Math.abs(deltaY) > 50) {
//         if (deltaY > 0) {
//           setCurrent((prev) => (prev + 1) % sections.length); // swipe up → next
//         } else {
//           setCurrent((prev) => (prev - 1 + sections.length) % sections.length); // swipe down → prev
//         }
//       }
//       touchStartY.current = null;
//     };

//     window.addEventListener("touchstart", handleTouchStart);
//     window.addEventListener("touchend", handleTouchEnd);

//     return () => {
//       window.removeEventListener("touchstart", handleTouchStart);
//       window.removeEventListener("touchend", handleTouchEnd);
//     };
//   }, []);

//   return (
//     <section
//       id="extra-sections"
//       className="relative h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-purple-50 overflow-hidden"
//     >
//       {sections.map((sec, idx) => (
//         <div
//           key={sec.id}
//           id={sec.id}
//           className={`absolute inset-0 flex flex-col items-center justify-center px-6 text-center transition-all duration-700 ${
//             idx === current
//               ? "opacity-100 translate-y-0 z-10"
//               : "opacity-0 translate-y-10 z-0"
//           }`}
//         >
//           <img
//             src={sec.img}
//             alt={sec.title}
//             className="w-24 h-24 mb-6 drop-shadow-lg"
//           />
//           <h2 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-600 mb-6">
//             {sec.title}
//           </h2>
//           <div className="text-lg md:text-xl max-w-2xl text-gray-700 leading-relaxed">
//             {sec.content}
//           </div>
//         </div>
//       ))}

//       {/* Dots Navigation */}
//       <div className="absolute bottom-6 flex gap-3">
//         {sections.map((_, idx) => (
//           <button
//             key={idx}
//             onClick={() => setCurrent(idx)}
//             className={`w-3 h-3 rounded-full transition ${
//               idx === current
//                 ? "bg-pink-500 scale-125"
//                 : "bg-gray-300 hover:bg-gray-400"
//             }`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// });

// export default ExtraSections;

import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import "../style/ExtraSections.css";
import CareerImg from "../assets/Sections/Career.png";
import FAQ from "../assets/Sections/FAQ.png";
import Blog from "../assets/Sections/Blog.png";
import Guides from "../assets/Sections/Guides.png";
import Privacy from "../assets/Sections/Privacy.png";
import Terms from "../assets/Sections/Terms&Conditions.png";
// import BlogCareersAfter10th from "./blogs/BlogCareersAfter10th";
// import BlogEngineeringVsCaVsMedical from "./blogs/BlogEngineeringVsCaVsMedical";
// import BlogWhenToSwitchJobs from "./blogs/BlogWhenToSwitchJobs";

const sections = [
    {
    id: "blog",
    title: "Blog ✍️",
    bg: "bg-gradient-to-br from-yellow-100 via-white to-yellow-50",
    content: "BLOG_DYNAMIC",
  },
  {
    id: "faqs",
    title: "FAQs ❓",
    bg: "bg-gradient-to-br from-indigo-100 via-white to-indigo-50",
    content: (
      <div className="grid md:grid-cols-2 gap-6 items-center">
        {/* Left: Text */}
        <div className="space-y-4 text-left">
          <p><strong>Q:</strong> How do I get started?<br/> <strong>A:</strong> Click “🚀 Start Now” to take the quiz!</p>
          <p><strong>Q:</strong> Is this service free?<br/> <strong>A:</strong> Yes, basic roadmap is free. Premium mentorship optional.</p>
          <p><strong>Q:</strong> Who are the mentors?<br/> <strong>A:</strong> 👩‍🏫 Industry professionals with 10+ years of experience.</p>
        </div>
        {/* Right: Illustration */}
        <img
          src={FAQ}
          alt="FAQs"
          className="rounded-xl shadow-lg"
        />
      </div>
    ),
  },
  {
    id: "careers",
    title: "Careers 💼",
    bg: "bg-gradient-to-br from-pink-100 via-white to-pink-50",
    content: (
      <div className="grid md:grid-cols-2 gap-6 items-center">
        {/* Left */}
        <div>
          <p className="mb-3">🌟 We’re always looking for passionate talents to join us:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Career Mentors 👨‍🏫</li>
            <li>UI/UX Designers 🎨</li>
            <li>Marketing Specialists 📈</li>
            <li>Full Stack Developers 💻</li>
          </ul>
          <p className="mt-4">
            📧 Send resume to <a href="mailto:connect@systematiccareerplanner.com" className="text-indigo-600">connect@systematiccareerplanner.com</a>
          </p>
        </div>
        {/* Right */}
        {/* <video
          autoPlay
          loop
          muted
          className="rounded-xl shadow-lg"
          src={CareerImg}
        />  */}
        <img
          src={CareerImg}
          alt="FAQs"
          className="rounded-xl shadow-lg"
        />
      </div>
    ),
  },
  {
    id: "guides",
    title: "Guides 📘",
    bg: "bg-gradient-to-br from-green-100 via-white to-green-50",
    content: (
      <div className="grid md:grid-cols-2 gap-6 items-center">
        <ol className="list-decimal list-inside space-y-2 text-left">
          <li>📝 Building your first resume</li>
          <li>🎤 Preparing for interviews</li>
          <li>💻 Roadmap for coding/design/business</li>
          <li>🌟 Mastering soft skills</li>
        </ol>
        <img
          src={Guides}
          alt="Guides"
          className="rounded-xl shadow-lg"
        />
      </div>
    ),
  },
  {
    id: "privacy",
    title: "Privacy Policy 🔒",
    bg: "bg-gradient-to-br from-purple-100 via-white to-purple-50",
    content: (
      <div className="grid md:grid-cols-2 gap-6 items-center">
        <p className="leading-relaxed text-left">
          We collect only essential data to personalize your roadmap. <br/>
          🔐 Your data is <strong>never shared</strong> with third parties. <br/>
          Request deletion anytime 👉{" "}
          <a href="mailto:connect@systematiccareerplanner.com" className="text-indigo-600 underline">
            connect@systematiccareerplanner.com
          </a>
        </p>
        <img
          src={Privacy}
          alt="Privacy"
          className="rounded-xl shadow-lg"
        />
      </div>
    ),
  },
  {
    id: "terms",
    title: "Terms & Conditions 📜",
    bg: "bg-gradient-to-br from-red-100 via-white to-red-50",
    content: (
      <div className="grid md:grid-cols-2 gap-6 items-center">
        <p className="leading-relaxed text-left">
          By using <strong>Systematic Career Planner</strong>, you agree to: <br/>
          ✅ Use the platform responsibly. <br/>
          ❌ Not misuse or copy data. <br/>
          📖 Respect our intellectual property. <br/>
          ⚖️ Follow laws and ethical practices.
        </p>
        <img
          src={Terms}
          alt="Terms"
          className="rounded-xl shadow-lg"
        />
      </div>
    ),
  },
];


const ExtraSections = forwardRef((props, ref) => {
  const [current, setCurrent] = useState(0);
  // const [activeBlog, setActiveBlog] = useState(null);
  const touchStartY = useRef(null);

  useImperativeHandle(ref, () => ({
    goToSection: (id) => {
      // setActiveBlog(null);
      const index = sections.findIndex((s) => s.id === id);
      if (index !== -1) setCurrent(index);
    },
  }));

  // Scroll (desktop)
  useEffect(() => {
    let cooldown = false;
    const handleScroll = (e) => {
      if (cooldown) return;
      cooldown = true;

      if (e.deltaY > 0) {
        setCurrent((prev) => (prev + 1) % sections.length);
      } else if (e.deltaY < 0) {
        setCurrent((prev) => (prev - 1 + sections.length) % sections.length);
      }

      setTimeout(() => (cooldown = false), 800);
    };

    window.addEventListener("wheel", handleScroll);
    return () => window.removeEventListener("wheel", handleScroll);
  }, []);

  // Swipe (mobile)
  useEffect(() => {
    const handleTouchStart = (e) => {
      touchStartY.current = e.touches[0].clientY;
    };
    const handleTouchEnd = (e) => {
      if (touchStartY.current === null) return;
      const deltaY = touchStartY.current - e.changedTouches[0].clientY;

      if (Math.abs(deltaY) > 50) {
        if (deltaY > 0) {
          setCurrent((prev) => (prev + 1) % sections.length);
        } else {
          setCurrent((prev) => (prev - 1 + sections.length) % sections.length);
        }
      }
      touchStartY.current = null;
    };

    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);


  // return (
  //   <section
  //     id="extra-sections"
  //     className="relative h-screen flex items-center justify-center overflow-hidden"
  //   >
  //     {sections.map((sec, idx) => (
  //       <div
  //         key={sec.id}
  //         id={sec.id}
  //         className={`absolute inset-0 flex flex-col items-center justify-center px-6 text-center transition-all duration-700 ${sec.bg} ${
  //           idx === current
  //             ? "opacity-100 translate-y-0 z-10"
  //             : "opacity-0 translate-y-10 z-0"
  //         }`}
  //       >
  //         <img
  //           src={sec.img}
  //           // alt={sec.title}
  //           className="w-24 h-24 mb-6 drop-shadow-lg"
  //         />
  //         <h2 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-600 mb-6">
  //           {sec.title}
  //         </h2>
  //         <div className="text-lg md:text-xl max-w-2xl text-gray-700 leading-relaxed">
  //           {sec.content}
  //         </div>
  //       </div>
  //     ))}

  //     {/* Dots Navigation */}
  //     <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-3 bg-white/70 backdrop-blur-sm px-4 py-2 rounded-full shadow-md z-20">
  //       {sections.map((_, idx) => (
  //         <button
  //           key={idx}
  //           onClick={() => setCurrent(idx)}
  //           className={`w-3 h-3 rounded-full transition ${
  //             idx === current
  //               ? "bg-pink-500 scale-125"
  //               : "bg-gray-300 hover:bg-gray-400"
  //           }`}
  //           title={_.title} // ✅ tooltip on hover
  //         />
  //       ))}
  //     </div>
  //   </section>
  // );
  //   // Blog article rendering
  // if (activeBlog === "careers-after-10th") return <BlogCareersAfter10th onBack={() => setActiveBlog(null)} />;
  // if (activeBlog === "engineering-vs-ca-vs-medical") return <BlogEngineeringVsCaVsMedical onBack={() => setActiveBlog(null)} />;
  // if (activeBlog === "when-to-switch-jobs") return <BlogWhenToSwitchJobs onBack={() => setActiveBlog(null)} />;

  // // Build dynamic blog content for the blog slide
  // const blogContent = (
  //   <div className="grid md:grid-cols-2 gap-6 items-center">
  //     <ul className="space-y-3 text-left">
  //       <li>
  //         <button onClick={() => setActiveBlog("careers-after-10th")} className="text-left hover:text-indigo-600 hover:underline transition font-medium">
  //           📌 Best Careers After 10th Standard
  //         </button>
  //       </li>
  //       <li>
  //         <button onClick={() => setActiveBlog("engineering-vs-ca-vs-medical")} className="text-left hover:text-indigo-600 hover:underline transition font-medium">
  //           📌 Engineering vs CA vs Medical — Which Path is Right?
  //         </button>
  //       </li>
  //       <li>
  //         <button onClick={() => setActiveBlog("when-to-switch-jobs")} className="text-left hover:text-indigo-600 hover:underline transition font-medium">
  //           📌 When to Switch Jobs — Signs &amp; Strategies
  //         </button>
  //       </li>
  //       <li className="text-gray-500 text-sm italic mt-2">📌 More articles coming soon...</li>
  //     </ul>
  //     <img
  //       src={Blog}
  //       alt="Blog"
  //       className="rounded-xl shadow-lg"
  //     />
  //   </div>
  // );
  // Build dynamic blog content for the blog slide
  // const blogContent = (
  //   <div className="grid md:grid-cols-2 gap-6 items-center">
  //     <ul className="space-y-3 text-left">
  //       <li>
  //         <button onClick={() => props.onBlogOpen("careers-after-10th")} className="text-left underline decoration-2 underline-offset-4 text-pink-600 decoration-pink-600  hover:text-indigo-600 hover:decoration-indigo-600 transition font-semibold cursor-pointer">
  //           📌 Best Careers After 10th Standard
  //         </button>
  //       </li>
  //       <li>
  //         <button onClick={() => props.onBlogOpen("engineering-vs-ca-vs-medical")} className="text-left underline decoration-2 underline-offset-4 text-pink-600 decoration-pink-600  hover:text-indigo-600 hover:decoration-indigo-600 transition font-semibold cursor-pointer">
  //           📌 Engineering vs CA vs Medical — Which Path is Right?
  //         </button>
  //       </li>
  //       <li>
  //         <button onClick={() => props.onBlogOpen("when-to-switch-jobs")} className="text-left underline decoration-2 underline-offset-4 text-pink-600 decoration-pink-600  hover:text-indigo-600 hover:decoration-indigo-600 transition font-semibold cursor-pointer">
  //           📌 When to Switch Jobs — Signs &amp; Strategies
  //         </button>
  //       </li>
  //       <li className="text-gray-500 text-sm italic mt-2">📌 More articles coming soon...</li>
  //     </ul>
  //     <img
  //       src={Blog}
  //       alt="Blog"
  //       className="rounded-xl shadow-lg"
  //     />
  //   </div>
  // );
  
  // Build dynamic blog content for the blog slide
  const blogArticles = [
    {
      id: "careers-after-10th",
      title: "Best Careers After 10th Standard",
      desc: "Science, Commerce, Arts or Vocational? Find the right stream for your strengths.",
      badge: "🔥 Trending",
      badgeColor: "bg-red-500",
    },
    {
      id: "engineering-vs-ca-vs-medical",
      title: "Engineering vs CA vs Medical",
      desc: "A detailed side-by-side comparison to help you pick the right career path.",
      badge: "⭐ New",
      badgeColor: "bg-yellow-500",
    },
    {
      id: "when-to-switch-jobs",
      title: "When to Switch Jobs — Signs & Strategies",
      desc: "7 warning signs it's time for a change and how to make the switch smartly.",
      badge: "📈 Popular",
      badgeColor: "bg-green-500",
    },
  ];

  // const blogContent = (
  //   <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-4xl mx-auto">
  //     {blogArticles.map((article) => (
  //       <button
  //         key={article.id}
  //         onClick={() => props.onBlogOpen(article.id)}
  //         className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 text-left overflow-hidden border border-gray-100"
  //       >
  //         {/* Badge */}
  //         <span className={`absolute top-3 right-3 ${article.badgeColor} text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-sm z-10`}>
  //           {article.badge}
  //         </span>

  //         {/* Gradient Top Bar */}
  //         <div className="h-2 w-full bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 group-hover:h-3 transition-all duration-300" />

  //         <div className="p-5">
  //           <h4 className="font-bold text-gray-900 group-hover:text-indigo-600 transition-colors text-base leading-snug mb-2">
  //             {article.title}
  //           </h4>
  //           <p className="text-gray-500 text-sm leading-relaxed">
  //             {article.desc}
  //           </p>
  //           <span className="inline-block mt-3 text-indigo-600 text-sm font-semibold group-hover:translate-x-1 transition-transform duration-200">
  //             Read Article →
  //           </span>
  //         </div>
  //       </button>
  //     ))}
  //   </div>
  // );

const blogContent = (
  <div className="grid lg:grid-cols-2 gap-10 items-center w-full max-w-6xl mx-auto px-4">

    {/* LEFT → Blog Cards */}
    <div className="grid sm:grid-cols-2 gap-4">
      {blogArticles.map((article) => (
        <button
          key={article.id}
          onClick={() => props.onBlogOpen(article.id)}
          className="group relative bg-white rounded-xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-left overflow-hidden border border-gray-100 p-4"
        >
          {/* Badge */}
          <span className={`absolute top-2 right-2 ${article.badgeColor} text-white text-[10px] font-semibold px-2 py-0.5 rounded-full`}>
            {article.badge}
          </span>

          {/* Top Bar */}
          <div className="h-1 w-full bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 mb-2" />

          {/* Title */}
          <h4 className="font-semibold text-gray-900 group-hover:text-indigo-600 text-sm leading-snug mb-1">
            {article.title}
          </h4>

          {/* Description */}
          <p className="text-gray-500 text-xs leading-relaxed line-clamp-2">
            {article.desc}
          </p>

          {/* CTA */}
          <span className="inline-block mt-2 text-indigo-600 text-xs font-medium group-hover:translate-x-1 transition-transform">
            Read → 
          </span>
        </button>
      ))}

      {/* Coming Soon */}
      <div className="col-span-full text-gray-500 text-xs italic mt-1">
        📌 More articles coming soon...
      </div>
    </div>

    {/* RIGHT → BIG IMAGE */}
    <div className="w-full flex justify-center">
      <img
        src={Blog}
        alt="Blog"
        className="w-full max-w-md lg:max-w-lg rounded-2xl shadow-xl object-contain"
      />
    </div>

  </div>
);

  return (
  <section
    id="extra-sections"
    className="relative h-screen flex items-center justify-center overflow-hidden"
  >
    {/* Slides */}
    <div className="absolute inset-0">
      {sections.map((sec, idx) => (
        <div
          key={sec.id}
          id={sec.id}
          className={`absolute inset-0 flex flex-col items-center justify-center px-6 text-center transition-all duration-700 ${sec.bg} ${
            idx === current
              ? "opacity-100 translate-y-0 z-10"
              : "opacity-0 translate-y-10 z-0"
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-600 mb-6">
            {sec.title}
          </h2>
          <div className="text-lg md:text-xl max-w-4xl text-gray-700 leading-relaxed">
            {sec.content === "BLOG_DYNAMIC" ? blogContent : sec.content}
          </div>
        </div>
      ))}
    </div>

    {/* Static Dots Navigation */}
    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-3 bg-white/70 backdrop-blur-sm px-4 py-2 rounded-full shadow-md z-20">
      {sections.map((s, idx) => (
        <button
          key={s.id}
          onClick={() => setCurrent(idx)}
          className={`w-3 h-3 rounded-full transition ${
            idx === current
              ? "bg-pink-500 scale-125"
              : "bg-gray-300 hover:bg-gray-400"
          }`}
          title={s.title}
        />
      ))}
    </div>
  </section>
);

});

export default ExtraSections;
